import { atom, useAtom } from "jotai";

import { type TxState, TxStatus } from "./EquityModal.types";

export const txStateAtom = atom<TxState>({
  status: TxStatus.IDLE,
});

export const useTxState = () => {
  const [txState, setTxState] = useAtom(txStateAtom);

  return {
    txState,
    setTxState,
  };
};
